import { Link } from "@tanstack/react-router";

import { env } from "@/env";
import { Card, Heading, textLink } from "@/ui";

export const OngoingSupportCard = () => {
  return (
    <Card className="flex flex-col gap-6 p-5 sm:flex-row sm:gap-12 sm:p-10">
      <img
        alt=""
        className="aspect-square size-40 self-center rounded-full border border-line object-cover sm:h-56 sm:w-56 sm:self-start"
        src="/assets/images/free-ongoing-expert-support.jpg"
      />

      <div className="flex flex-col gap-3">
        <Heading className="text-center sm:text-left" level={2}>
          Free Ongoing Expert Support
        </Heading>

        <ul className="flex list-inside list-disc flex-col gap-4 text-base leading-6 text-content-secondary sm:list-outside sm:text-xl sm:leading-8">
          <li>
            <span className="font-bold">
              <Link className={textLink} to="/messages">
                Message our care team
              </Link>{" "}
              or call{" "}
              <a className={textLink} href={`tel:${env.VITE_EO_CONTACT_NUMBER}`}>
                {env.VITE_EO_CONTACT_NUMBER}
              </a>
            </span>{" "}
            whenever you have questions about your plan or how you can use cannabis most
            effectively, safely and affordably.
          </li>

          <li>Respond to periodic, brief check-ins and surveys.</li>

          <li>Tune your plan and arrive at your optimal cannabis regimen.</li>
        </ul>
      </div>
    </Card>
  );
};
